/**
 * Pagination arrow icon.
 * Uses the theme's triangle.svg rotated for left/right direction.
 *
 * @param {Object} props           - Component props.
 * @param {string} props.direction - "next" or "previous".
 * @return {*} jsx
 */
export default function PaginationArrow( { direction }: { direction: 'next' | 'previous' } ) {
	// Rotate the upward-pointing triangle: -90° for previous (left), 90° for next (right).
	const rotation = direction === 'previous' ? -90 : 90;

	return (
		<svg
			aria-hidden="true"
			focusable="false"
			xmlns="http://www.w3.org/2000/svg"
			viewBox="0 0 20 11"
			style={ { transform: `rotate(${ rotation }deg)` } }
		>
			<path d="M10.4454 0.369597C9.95367 -0.122173 9.15635 -0.122174 8.66458 0.369597L0.371371 8.66281C-0.421918 9.4561 0.13992 10.8125 1.2618 10.8125L17.8482 10.8125C18.9701 10.8125 19.5319 9.4561 18.7387 8.66281L10.4454 0.369597Z" fill="currentColor" />
		</svg>
	);
}
